import React, { useState } from "react";
import styles from "./collapsed_container.module.css";

const CollapsedContainer = ({
  children, label, labelValue = null, edit = false,
  showContent, setShowContent,
  clickEdit = () => {}

}) => {

  // const [showContent, setShowContent] = useState(false);

  return (
    <div className={`${styles.container} ${!showContent && styles.container__collapsed}`}>
      <div className={styles.subtitle_button_container}>
        <p className={`subSubtitle subSubtitle__left ${styles.subtitle}`} onClick={() => setShowContent(!showContent)}>
          {label}
          {labelValue && <span className="text">{`: ${labelValue}`}</span>}
        </p>
        <div className="button_container_horizontal">
          {edit &&
            <button className="button_edit"
              onClick={clickEdit}
            />
          }
          <button
            className={`button_empty_square ${showContent ? 'arrow_up_white' : 'arrow_down_white'}`}
            onClick={() => setShowContent(!showContent)}
          />
        </div>

      </div>
      {showContent && <br />}
      {showContent && children}
    </div>
  );
};

export default CollapsedContainer;
